import React from 'react'

import { Dialog } from 'components'

const ReplicateMarkupsNoteDialog = ({ frameType, onConfirm, ...props }) => (
  <Dialog
    {...props}
    id='replicate-markups-note-dialog'
    title='Please Note'
    width={400}
    actions={[{ onClick: onConfirm, primary: true, label: 'OK, I understand' }]}
  >
    <p>
      Your products have to be unpublished for the edits to take effect (don't
      forget to republish afterwards).
    </p>
    <p>
      This pricing will be applied to
      all {frameType.id === 1 ? 'Art Prints' : 'Framed Prints'} for
      each size, but please note; for Landscape/Portrait formats, only these
      artworks will be updated. Similarly, for Square formats, only Square
      artworks will be updated.
    </p>
    <p>
      This process will only apply
      to {frameType.id === 1 ? 'Art Prints' : 'Framed Prints'}, please
      select {frameType.id === 1 ? 'Framed Print' : 'Art Print'} from
      the menu to
      update {frameType.id === 1 ? 'Framed Print' : 'Art Print'} pricing.
    </p>
  </Dialog>
)

export default ReplicateMarkupsNoteDialog



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/ViewContent/ReplicateMarkupsNoteDialog.js